<template>
<div v-show="show">
  <div :style="bannerStyle">
    <div style="height: 64px; position: relative; z-index: 200">
      <div style="width: 1178px; margin: 0 auto;">
      <img :src="bannerLogo" style="height: 40px; margin-top: 12px;"/>

      <el-button :style="btnStyle" @click="login">
        登录
      </el-button>
      </div>

    </div>

      <div style="width: 1178px; margin: 0 auto;">
    <div style="margin-top: 70px; color: #FFFFFF; font-size: 50px; height: 70px">
      爱奇艺联盟
    </div>
    <div style="margin-top: 20px; color: #FFFFFF; font-size: 20px; height: 30px">
      依托丰富广告资源与核心科技赋能，提供一站式流量变现解决方案，高效助力开发者收益最大化
    </div>
      </div>

      <img :src="rightLogo" style="float: right; height: 364px; margin-top: -254px; position: relative; z-index: 100"/>

  </div>

  <div style="text-align: center; padding-bottom: 86px; ">
    <div style="height: 114px; line-height: 114px; text-align: center; color: #1E232E; font-size: 36px">
      四大核心优势
    </div>
    <div style="display: inline-block; text-align: center; width: 278px; background: white; margin-right: 11px" class="border">
      <div style="padding-top: 44px; padding-bottom: 38px">
      <img :src="desc1Pic" style="height: 101px"/>
      <div style="margin-top: 40px; font-size: 26px; line-height: 28px">海量优质广告资源</div>
      <div style="margin-top: 16px; font-siez: 16px; line-height: 24px; color: #767C76">聚合全行业优质广告资源<br/>提供精细化解决方案</div>
      </div>
    </div>

    <div style="display: inline-block; width: 278px; background: white; margin-left: 11px; margin-right: 11px" class="border">
      <div style="padding-top: 44px; padding-bottom: 38px">
      <img :src="desc2Pic" style="height: 101px"/>
      <div style="margin-top: 40px; font-size: 26px; line-height: 28px">多样化广告样式</div>
      <div style="margin-top: 16px; font-siez: 16px; line-height: 24px; color: #767C76">丰富的广告形态与展现样式<br/>契合开发者应用的风格场景</div>
      </div>
    </div>

    <div style="display: inline-block; width: 278px; background: white; margin-left: 11px; margin-right: 11px" class="border">
      <div style="padding-top: 44px; padding-bottom: 38px">
      <img :src="desc3Pic" style="height: 101px"/>
      <div style="margin-top: 40px; font-size: 26px; line-height: 28px">最大化变现收益</div>
      <div style="margin-top: 16px; font-siez: 16px; line-height: 24px; color: #767C76">核心技术驱动精准匹配推广内容<br/>助力开发者收益最大化</div>
      </div>
    </div>

    <div style="display: inline-block; width: 278px; background: white; margin-left: 11px;" class="border">
      <div style="padding-top: 44px; padding-bottom: 38px">
      <img :src="desc4Pic" style="height: 101px"/>
      <div style="margin-top: 40px; font-size: 26px; line-height: 28px">专业定制化服务</div>
      <div style="margin-top: 16px; font-siez: 16px; line-height: 24px; color: #767C76">专业团队提供定制化服务<br/>高效扶持开发者的接入全流程</div>
      </div>
    </div>
  </div>

  <div style="background: #1E232E; font-size: 14px; line-height: 100px">
    <div style="display: inline-block; color: #787E8A; margin-left: 365px">
    <a href="https://union.iqiyi.com/platform/developerAgreement" target="_blank" style="color: #787E8A; text-decoration: none;">用户协议</a>
    <a href="https://union.iqiyi.com/platform/privacyPolicy" target="_blank" style="margin-left: 30px; color: #787E8A; text-decoration: none;">隐私政策</a>
    <a href="https://union.iqiyi.com/platform/developerNorms" target="_blank" style="margin-left: 30px; color: #787E8A; text-decoration: none;">开发者承诺函</a>
    <a href="https://union.iqiyi.com/platform/developerGuide" target="_blank" style="margin-left: 30px; color: #787E8A; text-decoration: none;">开发者合规指引</a>
    <a href="https://www.iqiyi.com/common/aboutus.html" target="_blank" style="margin-left: 30px; color: #787E8A; text-decoration: none;">关于爱奇艺</a>
    </div>

    <div style="display: inline-block; color: #787E8A; float: right; margin-right: 365px;">
    <span>媒体合作：yanmingxing@qiyi.com</span>
    </div>
  </div>

  <div style="background: black; color: #4D5057; font-size: 12px; line-height: 40px; text-align: center">
    Copyright©2021 iQIYI.All Rights Reserved.
  </div>

</div>

</template>
<script>
import webUtils from '@/tools/web-utils'
import Vue from 'vue';

  export default {
    computed: {
      indexBg: function() {
        return require('@/assets/image/index-banner-bg.png');
      },
      bannerLogo: function() {
        return require('@/assets/image/index-banner-logo.png');
      },
      loginBg: function() {
        return require('@/assets/image/index-btn-bg.png');
      },
      rightLogo: function() {
        return require('@/assets/image/index-right-logo.png');
      },
      desc1Pic: function() {
        return require('@/assets/image/index-desc-1-pic.png');
      },
      desc2Pic: function() {
        return require('@/assets/image/index-desc-2-pic.png');
      },
      desc3Pic: function() {
        return require('@/assets/image/index-desc-3-pic.png');
      },
      desc4Pic: function() {
        return require('@/assets/image/index-desc-4-pic.png');
      },
      bannerStyle: function() {
        return {
          backgroundImage: 'url(' + this.indexBg + ')',
          height: '364px'
        }
      },
      btnStyle: function() {
        return {
          background: 'url(' + this.loginBg + ') no-repeat',
          backgroundSize: '100% 100%',
          width: '100px',
          height: '40px',
          border: '0px',
          float: 'right',
          marginTop: '12px',
          fontSize: '18px',
          color: 'white',
        }
      }
    },
    data: function() {
      return {
        show: false
      }
    },
    methods: {
      login: function() {
        webUtils.redirect2QxLogin()
      }
    },
    mounted: function() {
      if (this.$store.state.accountInfo) {
        //已登录 跳转
        this.$router.push({ name: 'media'});
      } else {
        Vue.nextTick(() => this.show = true)
      }
    }
  }
</script>

<style scoped>
.border {
  box-shadow: 0 3px 3px -4px rgba(0,0,0,0.12), 0 9px 22px 8px rgba(0,0,0,0.05);
border-radius: 4px;
border-radius: 4px;
}


</style>

